var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "card-header py-3 d-md-flex justify-content-between align-items-start",
      class: _vm.customClass,
    },
    [
      _c("div", { staticClass: "d-flex flex-column" }, [
        _c("h6", { staticClass: "m-0 font-weight-bold text-primary" }, [
          _vm.routeNameForConditionalTitle &&
          _vm.$route.name === _vm.routeNameForConditionalTitle
            ? _c("span", [_vm._v(_vm._s(_vm.conditionalTitle))])
            : _c("span", [_vm._v(_vm._s(_vm.title))]),
        ]),
        _vm._v(" "),
        _c(
          "nav",
          {
            staticClass: "card-breadcrumb",
            staticStyle: {
              "background-color": "transparent",
              "box-shadow": "none",
              width: "auto",
            },
            attrs: { "aria-label": "breadcrumb" },
          },
          [
            _c(
              "ol",
              {
                staticClass: "breadcrumb mb-0 p-0",
                staticStyle: {
                  "background-color": "transparent",
                  "box-shadow": "none",
                },
              },
              _vm._l(_vm.breadcrumbItems, function (item, idx) {
                return _c(
                  "li",
                  {
                    key: idx,
                    staticClass: "breadcrumb-item",
                    class: { "breadcrumb-gray": _vm.isGrayBreadcrumb(item) },
                  },
                  [
                    item.to && !_vm.isGrayBreadcrumb(item)
                      ? _c("router-link", { attrs: { to: item.to } }, [
                          _vm._v(_vm._s(item.text)),
                        ])
                      : _c("span", [_vm._v(_vm._s(item.text))]),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mb-2" },
        [
          _vm._t("actions", function () {
            return [
              _vm.jsonData && _vm.jsonData.length > 0
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-dark btn-sm",
                      attrs: { "aria-label": "Print report" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("print", "student_data", "html")
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-print" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.jsonData && _vm.jsonData.length > 0
                ? _c(
                    "export-excel",
                    {
                      staticClass: "btn p-0 btn-sm export-btn",
                      attrs: {
                        data: _vm.jsonData,
                        name: `${_vm.excelFileName}.xls`,
                        worksheet: _vm.excelFileName,
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/assets/images/excel-icon.png",
                          alt: "Export Excel",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }